'use client';

import { c as _c } from "react/compiler-runtime";
import { HttpLink } from '@apollo/client';
import { ApolloNextAppProvider, ApolloClient, InMemoryCache } from '@apollo/client-integration-nextjs';
import type { PropsWithChildren } from 'react';

/**
 * Creates an Apollo Client configured for client-side usage.
 * This function is called once per request to create a new client instance.
 */
function makeClient() {
  const httpLink = new HttpLink({
    uri: '/api/graphql/',
    // Use 'include' to send cookies with requests for authentication
    credentials: 'include',
    // Important for App Router: disable Next.js fetch caching for all GraphQL operations.
    // This ensures queries and mutations always fetch fresh data and aren't cached by Next.js,
    // allowing Apollo Client to manage its own cache strategy.
    fetchOptions: {
      cache: 'no-store'
    }
  });
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: httpLink,
    defaultOptions: {
      watchQuery: {
        // Default to cache-and-network for real-time updates
        fetchPolicy: 'cache-and-network'
      }
    }
  });
}

/**
 * Apollo Provider wrapper for App Router client components.
 * Handles SSR streaming and cache hydration automatically.
 *
 * Use this instead of the standard ApolloProvider for App Router pages.
 */
export function ApolloWrapper(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ApolloNextAppProvider makeClient={makeClient}>{children}</ApolloNextAppProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}